"use client"

import { useState, useEffect } from "react"
import axios from "axios"

const useTopContractors = (naicsCode, normalizedAgencyName = null, limit = 6) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    // If no NAICS code is provided as a prop, don't make the API call
    if (!naicsCode) {
      setData([])
      setLoading(false)
      return
    }

    const fetchTopContractors = async () => {
      try {
        setLoading(true)

        // Create a payload that matches the working example
        const payload = {
          filters: {
            time_period: [
              { start_date: "2024-10-01", end_date: "2025-09-30" },
              { start_date: "2023-10-01", end_date: "2024-09-30" },
              { start_date: "2022-10-01", end_date: "2023-09-30" },
              { start_date: "2021-10-01", end_date: "2022-09-30" },
            ],
            award_type_codes: ["A", "B", "C", "D"],
            naics_codes: [naicsCode],
            recipient_type_names: [
              "small_business",
              "minority_owned_business",
              "woman_owned_business",
              "veteran_owned_business",
              "service_disabled_veteran_owned_business",
            ],
            award_amounts: [{ lower_bound: 1000000, upper_bound: 50000000 }],
          },
          fields: [
            "Award ID",
            "Recipient Name",
            "Award Amount",
            "Total Outlays",
            "Description",
            "Contract Award Type",
            "Recipient UEI",
            "Recipient Location",
            "Primary Place of Performance",
            "def_codes",
            "COVID-19 Obligations",
            "COVID-19 Outlays",
            "Infrastructure Obligations",
            "Infrastructure Outlays",
            "Awarding Agency",
            "Awarding Sub Agency",
            "Start Date",
            "End Date",
            "NAICS",
            "PSC",
            "recipient_id",
            "prime_award_recipient_id",
          ],
          page: 1,
          limit: 18, // Increased from 6 to support "Show More"
          sort: "Award Amount",
          order: "desc",
          subawards: false,
          auditTrail: "Results Table - Spending by award search",
        }

        // Add agency filter if provided
        if (normalizedAgencyName) {
          payload.filters.agencies = [
            {
              type: "awarding",
              tier: "toptier",
              name: normalizedAgencyName,
            },
          ]
        }

        const response = await axios.post("https://api.usaspending.gov/api/v2/search/spending_by_award/", payload)

        setData(response.data.results || [])
      } catch (err) {
        console.error("Error fetching top contractors:", err)
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchTopContractors()
  }, [naicsCode, normalizedAgencyName, limit])

  return { data, loading, error }
}

export default useTopContractors
